import ISF5ApiUrls from 'src/apiUrls/ISF5ApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useEffect, useState, useContext, useRef } from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { AceIsfTranslationContext } from '../contexts/ACEISFTranslationContext'
import { useFormContext, useWatch } from 'react-hook-form';
import ConfirmDialog from '../../common/ConfirmDialog'
import { useLocation } from 'react-router-dom'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification, onSetLoading }) {
  const onSuccessCallback = useRef((e) =>
    history.push(`${pathMap.ACEISF5}/edit/` + e.id)
  )
  
  const loc = useLocation()
  let formikPropsData
  if (loc.state !== undefined && loc.state.shouldRerender === undefined) {
    formikPropsData = {
      ...FormProperties.formikProps,
      // initialValues: DataFlattener.parse(loc.state)
      initialValues: loc.state
    }
  } else {
    formikPropsData = FormProperties.formikProps
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={formikPropsData}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: ISF5ApiUrls.POST,
            onSuccess: (e) => {
              showNotification('success', 'Created successfully.')
              onSuccessCallback.current(e)
              // onSetLoading(false)
            }
          }}
          renderButtonSection={(loading) => (
            <ButtonSection
              history={history}
              loading={loading}
              // onSetLoading={onSetLoading}
            />
          )}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage

function ButtonSection(props) {
  const { history, loading, onSetLoading } = props

  const [confirmDialog, setConfirmDialog] = useState(false)
  const {
    formState: { isSubmitting },
    getValues
  } = useFormContext()
  const { getTranslatedText } = useContext(AceIsfTranslationContext)

  // useEffect(() => {
  //   // onSetLoading(loading)
  // }, [loading])

  return (
    <>
      <Grid container justify='space-between'>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={isSubmitting || loading}
            onClick={() => setConfirmDialog(true)}
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <Grid container spacing={2}>
            <Grid item xs='auto'>
              <CngButton
                type='submit'
                color='primary'
                disabled={isSubmitting || loading}
              >
                {getTranslatedText('ACE_ISF', 'saveButton')}
              </CngButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.ACEISF5_LIST_VIEW)}
        content="All progress in this session will be lost and cant't be restored. Are you sure about this?"
        okMsg='Yes, discard'
        cancelMsg='Continue editing'
        title='Discard'
      />
    </>
  )
}
